import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';

@Injectable({
  providedIn: 'root'
})
export class UserRolesService {

  constructor(
    private _http:HttpClient
  ) { }

  public getPaginatedUserRoles(page, pp): Observable<iHttpPaginatedResponse> {
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/userRoles?page=${page}&pp=${pp}`).pipe(
        map(res => {
            return res;
        })
    );
  }

  public getUserRole(id:number): Observable<any>{
    return this._http.get(environment.apiEndpoint + '/api/admin/userRoles/' + id).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public addNewUserRole(name:string): Observable<any>{
    return this._http.post(environment.apiEndpoint + '/api/admin/userRoles', {name:name}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public updateUserRole(name:string, id:number): Observable<any>{
    return this._http.put(environment.apiEndpoint + '/api/admin/userRoles/' + id, {name:name}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
